import { makeAutoObservable } from 'mobx';

class StorageStore {
	rootStore;
	selectStorage = [];

	constructor(root) {
		makeAutoObservable(this);
		this.rootStore = root;
	}

	isIncludeStorage(data) {
		return this.selectStorage.find((storage) => storage.url === data.url);
	}

	setSelectStorage(data) {
		const isInclude = this.isIncludeStorage(data);
		if (isInclude) {
			this.selectStorage = this.selectStorage.filter(
				(storage) => storage.name !== data.name,
			);
		} else {
			this.selectStorage.push(data);
		}
	}

	setSelectCategoryItem(list) {
		const isInclude = this.isIncludeStorage(list[0]);
		if (isInclude) {
			this.selectStorage = this.selectStorage.filter(
				(item) => !list.some((item2) => item.url === item2.url),
			);
		} else {
			this.selectStorage = [...this.selectStorage, ...list];
		}
	}

	async downloadFilesFromURLs() {
		const fails = [];
		for (let storage of this.selectStorage) {
			const url = storage?.url;
			try {
				// ZIP 파일인지 확인
				const isZip = url.toLowerCase().endsWith('.zip');

				const response = await fetch(url, {
					headers: {
						'Cache-Control': 'no-cache',
						Pragma: 'no-cache',
						Accept: isZip ? 'application/zip' : '*/*',
					},
				});

				if (!response.ok) {
					throw new Error(`HTTP error! status: ${response.status}`);
				}

				const blob = await response.blob();
				if (blob.size === 0) {
					throw new Error('Downloaded file is empty');
				}

				// ZIP 파일의 경우 올바른 MIME 타입으로 새 Blob 생성
				const finalBlob = isZip
					? new Blob([blob], { type: 'application/zip' })
					: blob;

				const filename = this.getFilenameFromURL(url);
				this.saveBlobAsFile(finalBlob, filename);
			} catch (error) {
				console.error(`다운로드 실패: ${url}`, error);
				storage.error = error;
				fails.push(storage);
			}
		}

		if (fails.length > 0) {
			for (let fail of fails) {
				alert(`다운로드를 실패했습니다: ${fail.name}`);
			}
		} else {
			alert('다운로드를 완료했습니다.');
		}
	}

	getFilenameFromURL(url) {
		const name = decodeURI(url.split('/').pop());
		return name;
	}

	saveBlobAsFile(blob, filename) {
		const link = document.createElement('a');
		// URL.createObjectURL 전에 revokeObjectURL로 이전 URL 정리
		if (link.href) {
			URL.revokeObjectURL(link.href);
		}
		link.href = URL.createObjectURL(blob);
		link.download = filename;
		link.click();
		// 메모리 누수 방지를 위해 지연된 URL 해제
		setTimeout(() => URL.revokeObjectURL(link.href), 100);
	}
}

export default StorageStore;
